module.exports = __webpack_public_path__ + "static/urbandine-be94edd7cb71c806a6f9360fe5a75205.jpeg";